import { render, staticRenderFns } from "./Incoming.vue?vue&type=template&id=61f528fc&scoped=true&"
import script from "./Incoming.vue?vue&type=script&lang=ts&"
export * from "./Incoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f528fc",
  null
  
)

export default component.exports